/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * repoint: its upstream authorization server changes to another single provider. clear: it is left with no single provider and loses its upstream. resignin: its upstream is unchanged but its client is replaced, so everyone signs in again. client_removed: a gateway loses a provider client its members sign in through.
 */
export const ServerIdentityImpactServerImpact = {
  Repoint: "repoint",
  Clear: "clear",
  Resignin: "resignin",
  ClientRemoved: "client_removed",
} as const;
/**
 * repoint: its upstream authorization server changes to another single provider. clear: it is left with no single provider and loses its upstream. resignin: its upstream is unchanged but its client is replaced, so everyone signs in again. client_removed: a gateway loses a provider client its members sign in through.
 */
export type ServerIdentityImpactServerImpact = ClosedEnum<
  typeof ServerIdentityImpactServerImpact
>;

/**
 * Whether this is an MCP server or a gateway.
 */
export const ServerIdentityImpactServerKind = {
  McpServer: "mcp_server",
  Gateway: "gateway",
} as const;
/**
 * Whether this is an MCP server or a gateway.
 */
export type ServerIdentityImpactServerKind = ClosedEnum<
  typeof ServerIdentityImpactServerKind
>;

/**
 * An MCP server or gateway a proposed binding change affects.
 */
export type ServerIdentityImpactServer = {
  /**
   * The MCP server or gateway id.
   */
  id: string;
  /**
   * repoint: its upstream authorization server changes to another single provider. clear: it is left with no single provider and loses its upstream. resignin: its upstream is unchanged but its client is replaced, so everyone signs in again. client_removed: a gateway loses a provider client its members sign in through.
   */
  impact: ServerIdentityImpactServerImpact;
  /**
   * Whether this is an MCP server or a gateway.
   */
  kind: ServerIdentityImpactServerKind;
  /**
   * The MCP server or gateway name.
   */
  name?: string | undefined;
  /**
   * The owning project.
   */
  projectId: string;
  /**
   * The name of the owning project.
   */
  projectName: string;
  /**
   * The MCP server slug. Gateways have none.
   */
  slug?: string | undefined;
};

/** @internal */
export const ServerIdentityImpactServerImpact$inboundSchema: z.ZodMiniEnum<
  typeof ServerIdentityImpactServerImpact
> = z.enum(ServerIdentityImpactServerImpact);

/** @internal */
export const ServerIdentityImpactServerKind$inboundSchema: z.ZodMiniEnum<
  typeof ServerIdentityImpactServerKind
> = z.enum(ServerIdentityImpactServerKind);

/** @internal */
export const ServerIdentityImpactServer$inboundSchema: z.ZodMiniType<
  ServerIdentityImpactServer,
  unknown
> = z.pipe(
  z.object({
    id: z.string(),
    impact: ServerIdentityImpactServerImpact$inboundSchema,
    kind: ServerIdentityImpactServerKind$inboundSchema,
    name: z.optional(z.string()),
    project_id: z.string(),
    project_name: z.string(),
    slug: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "project_id": "projectId",
      "project_name": "projectName",
    });
  }),
);

export function serverIdentityImpactServerFromJSON(
  jsonString: string,
): SafeParseResult<ServerIdentityImpactServer, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ServerIdentityImpactServer$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ServerIdentityImpactServer' from JSON`,
  );
}
